export function getScroll() {
  return window.pageYOffset;
}

export function getWidth() {
  return window.innerWidth;
}

export function getHeight() {
  return window.innerHeight;
}

export function isRetina() {
  const mediaQuery =
    '(-webkit-min-device-pixel-ratio: 1.5),(min--moz-device-pixel-ratio: 1.5),(-o-min-device-pixel-ratio: 3/2),(min-resolution: 1.5dppx)';
  if (window.devicePixelRatio > 1) {
    return true;
  }
  return window.matchMedia && window.matchMedia(mediaQuery).matches;
}

// function arguments match first 5 variable assignments
/* eslint-disable */
export function formatMoney(n, p, s, t, d) {
  let number = n || 0;
  const places = !isNaN((p = Math.abs(p))) ? p : 0;
  const symbol = s !== undefined ? s : '$';
  const thousand = t || ',';
  const decimal = d || '.';
  const negative = number < 0 ? '-' : '';
  const i =
    parseInt((number = Math.abs(+number || 0).toFixed(places)), 10) + '';
  let j = (j = i.length) > 3 ? j % 3 : 0;

  return (
    symbol +
    negative +
    (j ? i.substr(0, j) + thousand : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) +
    (places
      ? decimal +
        Math.abs(number - i)
          .toFixed(places)
          .slice(2)
      : '')
  );
}
/* eslint-enable */

export function getQueryStrings(qs) {
  // remove any preceding url and split
  const querystring = qs.substring(qs.indexOf('?') + 1).split('&');
  const params = {};
  let pair;
  const d = decodeURIComponent;

  // march and parse
  for (let i = querystring.length - 1; i >= 0; i -= 1) {
    pair = querystring[i].split('=');
    params[d(pair[0])] = d(pair[1]);
  }

  return params;
}

export function getTimeFromSeconds(seconds) {
  let hh = 0;
  let mm = 0;
  let ss = 0;
  let t = '';

  if (seconds > 0) {
    // Multiply by 1000 because Date() requires miliseconds
    const date = new Date(seconds * 1000);
    hh = date.getUTCHours();
    mm = date.getUTCMinutes();
    ss = date.getSeconds();
  }

  // Make sure there are two-digits
  /* eslint-disable */
  if (hh != 0) {
    if (hh < 10) {
      t += '0' + hh + ':';
    } else {
      t += hh + ':';
    }
  }
  if (mm < 10) {
    t += '0' + mm + ':';
  } else {
    t += mm + ':';
  }
  if (ss < 10) {
    t += '0' + ss;
  } else {
    t += ss;
  }

  return t;
  /* eslint-enable */
}

// returns a random number
export function randomIntFromInterval(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

// creates an array of random numbers that add up to 100
// useful for testing percentage values that
export function createRandomNumbers(num) {
  const arr = [];
  const result = [];
  for (let i = 0; i < num - 1; i += 1) {
    arr.push(randomIntFromInterval(1, 99));
  }
  arr.push(0, 100);
  arr.sort((a, b) => {
    return a - b;
  });
  for (let i = 0; i < num; i += 1) {
    result.push(arr[i + 1] - arr[i]);
  }
  return result;
}

export function numberWithCommas(x) {
  // return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  return x.toLocaleString();
}

export function capitalise(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// degrees to radians
export function radians(deg) {
  return (deg * Math.PI) / 180;
}

// radians to degrees
export function degrees(rad) {
  return (rad * 180) / Math.PI;
}

export function isIE() {
  const ua = window.navigator.userAgent;

  // Test values; Uncomment to check result …

  // IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

  // IE 12 / Spartan
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

  // Edge (IE 12+)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  const msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  const trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    const rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  const edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}

// does browser use intersectoin observer - probably cna't rely on this yet
export function isIntersectionObserver() {
  return (
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype
  );
}

// generate random boolean
export function getRandomBoolean() {
  return Math.random() >= 0.5;
}

// is provided date a weekday.
export function isWeekday(date) {
  return date.getDay() % 6 !== 0;
}
/* 
console.log(isWeekday(new Date(2021, 0, 11)));
// Result: true (Monday)
console.log(isWeekday(new Date(2021, 0, 10)));
// Result: false (Sunday)
*/

// Is Browser tab in view
export function isBrowserTabInView() {
  return document.hidden;
}

// Is number odd or even
export function isEven(num) {
  return num % 2 === 0;
}

// Get time from date
export function timeFromDate(date) {
  return date.toTimeString().slice(0, 8);
}

// Number to fixed decimal point
export function toFixed(n, fixed) {
  return ~~(Math.pow(10, fixed) * n) / Math.pow(10, fixed); // eslint-disable-line
}
/*
// Examples
toFixed(25.198726354, 1);       // 25.1
toFixed(25.198726354, 2);       // 25.19
toFixed(25.198726354, 3);       // 25.198
toFixed(25.198726354, 4);       // 25.1987
toFixed(25.198726354, 5);       // 25.19872
toFixed(25.198726354, 6);       // 25.198726
*/

// check if an element is in focus
export function elementIsInFocus(el) {
  return el === document.activeElement;
}

// check if the current user has touch events supported
export function touchSupported() {
  return (
    'ontouchstart' in window ||
    (window.DocumentTouch && document instanceof window.DocumentTouch)
  );
}

// check if device is an apppple machine
export function isAppleDevice() {
  return /Mac|iPod|iPhone|iPad/.test(navigator.platform);
}

// political party colours
export function partyColours(party) {
  return party === 'LP'
    ? '#006fb9'
    : party === 'ALP'
    ? '#c60f32'
    : party === 'IND'
    ? '#6F2A93'
    : party === 'NP'
    ? '#006fb9'
    : party === 'CLP'
    ? '#006fb9'
    : party === 'GRN'
    ? '#00953d'
    : party === 'LNQ'
    ? '#006fb9'
    : party === 'LNP'
    ? '#006fb9'
    : party === 'PUP'
    ? '#9f0cb4'
    : party === 'KAP'
    ? '#525e6d'
    : party === 'ON'
    ? '#f04dca'
    : party === 'BELL'
    ? '#fc0fc0'
    : party === 'XEN'
    ? '#ff6300'
    : party === 'AUC'
    ? '#f08080'
    : party === 'FACN'
    ? '#b22222'
    : party === 'UAPP'
    ? '#ffd300'
    : party === 'WAP'
    ? '#d2691e'
    : party === 'ASP'
    ? '#4169e1'
    : party === 'SAL'
    ? '#808000'
    : party === 'GAP'
    ? '#b8860b'
    : party === 'FUT'
    ? '#90ee90'
    : party === 'FLUX'
    ? '#d83d8b'
    : party === 'AJP'
    ? '#191970'
    : party === 'AFN'
    ? '#f08080'
    : party === 'DLP'
    ? '#daa520'
    : party === 'RUA'
    ? '#da70d6'
    : party === 'CEC'
    ? '#db7093'
    : party === 'VNS'
    ? '#8b4513'
    : party === 'SEP'
    ? '#b0c4de'
    : party === 'DHJP'
    ? '#bdb76b'
    : party === 'REAS'
    ? '#008080'
    : party === 'SPP'
    ? '#c71585'
    : party === 'AUD'
    ? '#7b68ee'
    : party === 'CPP'
    ? '#1e90ff'
    : party === 'AUP'
    ? '#d2b48c'
    : party === 'LDP'
    ? '#bc8f8f'
    : party === 'LAOL'
    ? '#dda0dd'
    : party === 'CDP'
    ? '#d8bfd8'
    : party === 'NCP'
    ? '#32cd32'
    : party === 'ABFA'
    ? '#ff6347'
    : party === 'AWP'
    ? '#6b8f23'
    : party === 'IMO'
    ? '#FA8072'
    : party === 'none'
    ? '#ef8636'
    : '#525e6d';
}

// political party colours
export function partyColoursRGB(party) {
  return party === 'LP'
    ? [0, 111, 185]
    : party === 'ALP'
    ? [198, 15, 50]
    : party === 'IND'
    ? [111, 42, 147]
    : party === 'NP'
    ? [0, 111, 185]
    : party === 'CLP'
    ? [0, 111, 185]
    : party === 'GRN'
    ? [0, 149, 61]
    : party === 'LNQ'
    ? [0, 111, 185]
    : party === 'LNP'
    ? [0, 111, 185]
    : party === 'PUP'
    ? [159, 12, 180]
    : party === 'KAP'
    ? [82, 94, 109]
    : party === 'ON'
    ? [240, 77, 202]
    : party === 'BELL'
    ? [252, 15, 192]
    : party === 'XEN'
    ? [255, 99, 0]
    : party === 'none'
    ? [239, 134, 54]
    : [82, 94, 109];
}

export function getCoordinates(id) {
  return id === 'VIC'
    ? { lat: -37.8131869, long: 144.96297960000004, zoom: 10.4 }
    : id === 'NSW'
    ? { lat: -33.873651, long: 151.10688960000007, zoom: 10.1 }
    : id === 'QLD'
    ? { lat: -27.4709331, long: 153.02350239999998, zoom: 10.5 }
    : id === 'SA'
    ? { lat: -34.9487264, long: 138.59994529999994, zoom: 10.2 }
    : id === 'WA'
    ? { lat: -31.9728536, long: 115.89733890000006, zoom: 10.5 }
    : id === 'TAS'
    ? { lat: -42.9019032, long: 147.32381480000004, zoom: 11.1 }
    : id === 'NT'
    ? { lat: -12.4628198, long: 130.86176939999998, zoom: 11.2 }
    : id === 'ACT'
    ? { lat: -35.3219998, long: 149.12868430000003, zoom: 10.9 }
    : 'problem with country ID';
}

// check state
export function checkState(str) {
  console.log('str ', str);
  return str.indexOf('New South Wales') !== -1
    ? 'NSW'
    : str.indexOf('Victoria') !== -1
    ? 'VIC'
    : str.indexOf('Queensland') !== -1
    ? 'QLD'
    : str.indexOf('South Australia') !== -1
    ? 'SA'
    : str.indexOf('Western Australia') !== -1
    ? 'WA'
    : str.indexOf('Tasmania') !== -1
    ? 'TAS'
    : str.indexOf('Northern Territory') !== -1
    ? 'NT'
    : str.indexOf('Australian Capital Territory') !== -1
    ? 'ACT'
    : '';
}
